import { render, staticRenderFns } from "./AddResponder.vue?vue&type=template&id=9f0b648e&"
import script from "./AddResponder.vue?vue&type=script&lang=js&"
export * from "./AddResponder.vue?vue&type=script&lang=js&"
import style0 from "./AddResponder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f0b648e')) {
      api.createRecord('9f0b648e', component.options)
    } else {
      api.reload('9f0b648e', component.options)
    }
    module.hot.accept("./AddResponder.vue?vue&type=template&id=9f0b648e&", function () {
      api.rerender('9f0b648e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/Autoresponders/AddResponder.vue"
export default component.exports